import axios from "axios";
export const documentService = {
  getAll,
  getListFromFile,
  getAllBatchs
};

var qs = require("qs");

function getAllBatchs(params) {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  return axios
    .get("Tracking/getBatches", {
      params: params,
      cancelToken: source.token,
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: "repeat" });
      }
    })
    .then(handleResponse)
    .catch(error => {
      return Promise.reject(error);
    });
}

function getAll(params) {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  return axios
    .get("Tracking/DocumentList", {
      params: params,
      cancelToken: source.token,
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: "repeat" });
      }
    })
    .then(handleResponse)
    .catch(error => {
      return Promise.reject(error);
    });
}

function getListFromFile(params) {
  return axios
    .get("Tracking/DocumentList", {
      params: params
      /*paramsSerializer: function(params) {
           return qs.stringify(params, {arrayFormat: 'repeat'})
        },*/
    })
    .then(handleResponse)
    .catch(error => {
      return Promise.reject(error);
    });
}

function handleResponse(response) {
  if (response.data.Errors && response.data.Errors.length > 0) {
    return Promise.reject(response.data.Errors[0]);
  }
  if (
    response.data.ValidationErrors &&
    response.data.ValidationErrors.length > 0
  ) {
    return Promise.reject(response.data.ValidationErrors[0]);
  }
  return Promise.resolve(response.data);
}
